import { render, staticRenderFns } from "./ServiceVisitsCalendar.vue?vue&type=template&id=dc8e7e4e&scoped=true&"
import script from "./ServiceVisitsCalendar.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitsCalendar.vue?vue&type=style&index=0&id=dc8e7e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8e7e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
